import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Gift, ShieldCheck } from 'lucide-react';
export function SolutionIntro() {
  return <section className="py-20 px-4 bg-brand-black text-white text-center border-y border-white/5" data-id="element-144">
      <div className="max-w-4xl mx-auto" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-146">
          <ShieldCheck className="w-16 h-16 text-brand-green mx-auto mb-6" data-id="element-147" />
          <h2 className="font-display text-4xl md:text-5xl uppercase mb-6" data-id="element-148">
            La solución <span className="text-brand-green" data-id="element-149">definitiva</span>
          </h2>
          <p className="font-body text-xl text-gray-300 mb-12" data-id="element-150">
            Te presentamos{' '}
            <strong className="text-white" data-id="element-151">Padel Zurdo Pro</strong>: el único
            sistema paso a paso que te enseña a jugar, pensar y ganar como un
            verdadero zurdo.
          </p>

          <div className="flex flex-col md:flex-row justify-center items-center gap-8 md:gap-16" data-id="element-152">
            <div className="flex flex-col items-center" data-id="element-153">
              <div className="bg-brand-green/15 p-4 rounded-full mb-4 border border-brand-green/30" data-id="element-154">
                <BookOpen className="w-10 h-10 text-brand-green" data-id="element-155" />
              </div>
              <span className="font-display text-2xl" data-id="element-156">6 TOMOS</span>
              <span className="font-body text-gray-400" data-id="element-157">Completos</span>
            </div>
            <div className="hidden md:block w-px h-20 bg-white/10" data-id="element-158"></div>
            <div className="flex flex-col items-center" data-id="element-159">
              <div className="bg-brand-green/15 p-4 rounded-full mb-4 border border-brand-green/30" data-id="element-160">
                <Gift className="w-10 h-10 text-brand-green" data-id="element-161" />
              </div>
              <span className="font-display text-2xl" data-id="element-162">3 BONOS</span>
              <span className="font-body text-gray-400" data-id="element-163">Exclusivos</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}